"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeLastWhile = exports.takeLastUntil = exports.last = exports.first = exports.take = void 0;
var maybeasy_1 = require("maybeasy");
function take(howMany, things) {
    var doit = function (things) {
        return things.slice(0, howMany);
    };
    return typeof things === 'undefined' ? doit : doit(things);
}
exports.take = take;
var first = function (things) { return maybeasy_1.fromNullable(take(1, things)[0]); };
exports.first = first;
var last = function (things) {
    return maybeasy_1.fromEmpty(things).map(function (ts) { return ts[ts.length - 1]; });
};
exports.last = last;
function takeLastUntil(fn, ts) {
    var doit = function (ts) {
        var i;
        for (i = ts.length; i > 0; i--) {
            if (fn(ts[i - 1])) {
                break;
            }
        }
        return ts.slice(i);
    };
    return typeof ts === 'undefined' ? doit : doit(ts);
}
exports.takeLastUntil = takeLastUntil;
function takeLastWhile(fn, ts) {
    var doit = function (ts) {
        var i;
        for (i = ts.length; i > 0; i--) {
            if (!fn(ts[i - 1])) {
                break;
            }
        }
        return ts.slice(i);
    };
    return typeof ts === 'undefined' ? doit : doit(ts);
}
exports.takeLastWhile = takeLastWhile;
